import { Card } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from './common/constants';

const NoAccess = () => {
  return (
    <Card className="no-access-height">
      <div className="gx-page-error-container">
        <div className="gx-page-error-content">
          <h2 className="gx-text-center">
            Oops, an error has occurred. Access not found!
          </h2>
          <p className="gx-text-center">
            <Link className="gx-btn gx-btn-primary" to={ROUTES?.APPS}>
              Home
            </Link>
          </p>
        </div>
      </div>
    </Card>
  );
};

export default NoAccess;
